import { cn } from '@/lib/utils'

type Props = {
  text?: string
  type?: 'horizontal' | 'vertical'
  className?: string
}
export const Divider = ({ text, type = 'horizontal', className }: Props) => {
  const orientation =
    type === 'horizontal' ? 'my-4 h-[1px] w-full' : 'mx-4 w-[1px] h-full'

  return (
    <div className={cn(`relative ${orientation} bg-neutral-900/20`, className)}>
      {text && (
        <span className='absolute left-12 top-0 -translate-y-1/2 bg-white px-2 text-xs text-neutral-900'>
          {text}
        </span>
      )}
    </div>
  )
}
